import * as Yup from 'yup';
import type { IncidentReportDeliveryHoursEntry } from 'components/CriticalIncident/interfaces';

export const MAX_DELIVERY_HOURS_ENTRIES = 15;

// Exported so the component can seed a fresh entry (on add, and defensively on mount/remove) with
// the same shape used for the section's default — one source of truth for "what an empty entry is".
export const EMPTY_ENTRY: IncidentReportDeliveryHoursEntry = {
    date: null,
    durationHours: null,
    activity: '',
    feeLine: '',
    completed: null,
};

const deliveryHoursEntrySchema = Yup.object({
    date: Yup.string().required('error_required_field'),
    durationHours: Yup.number().required('error_required_field'),
    activity: Yup.string().required('error_required_field'),
    feeLine: Yup.string().required('error_required_field'),
    completed: Yup.boolean().required('error_required_field'),
});

// Requirement 1: a single entry is displayed by default — no "were there any..." gate exists for
// this section, so (unlike sibling sections) the default itself must already contain one entry
// rather than starting from `[]` behind a boolean.
export const initialValues = {
    entries: [{ ...EMPTY_ENTRY }],
};

export const validationSchema = Yup.object({
    entries: Yup.array().of(deliveryHoursEntrySchema).min(1, 'error_required_field'),
});
